import { orderClient, useQuery } from "@trueskin-web/apis"
import { useAuth } from "@trueskin-web/context"
import { getCountry } from "@trueskin-web/locales"
import { storageService, vwoService } from "@trueskin-web/services"

const storageKeys = storageService.getStorageKeys()

const useCurrentPresets = () => {
  const {
    user: {
      userType,
      subscription,
      preferredPresetForInitialPurchase,
      preferredPresetForRepurchase,
    },
  } = useAuth()

  const country = getCountry()

  const testPresetTypeForInitialPurchase = vwoService.getTestPresetType()
  const tofuToCorePreferredPreset = storageService.getItem({
    id: storageKeys.TOFU_TO_CORE_MAIN_PRESET_ID,
  })

  const preferredPreset =
    subscription && preferredPresetForRepurchase
      ? preferredPresetForRepurchase.preset
      : // TODO: update test preset types to accommodate CH (Swiss) users
      country === "DE" && testPresetTypeForInitialPurchase
      ? testPresetTypeForInitialPurchase
      : tofuToCorePreferredPreset && userType === "tofu"
      ? tofuToCorePreferredPreset
      : preferredPresetForInitialPurchase.preset

  return useQuery("currentPresets", () =>
    orderClient.getCurrentPresets(preferredPreset)
  )
}

export default useCurrentPresets
